<template>
  <section v-if="items.length > 0" :class="['accordion', {extended: isExtended}]">
    <div class="left">
      <h2 @click.stop.prevent="toggleExtended">{{ title }}</h2>
      <p class="download_link">
        <a :href="filepath" v-translate @click="showMessage">Stáhnout vše</a>
      </p>
    </div>
    <div class="right files">
      <document-item
          v-for="item in items"
          :item="item"
          :key="item.id"
          :route="host"
      ></document-item>
    </div>
  </section>
</template>

<script>
import DocumentItem from "@/components/views/downloads/documents/DocumentItem"
import message from "@/components/mixins/message"

export default {
  name: "Documents",
  components: {DocumentItem},
  mixins: [message],
  data() {
    return {
      isExtended: false
    }
  },
  props: {
    title: String,
    dir: String,
    items: Array
  },
  created(DownloadService) {
    this.downloadService = DownloadService
  },
  computed: {
    host() {
      return this.downloadService.getFullRouteForFileDownload()
    },
    filepath() {
      return this.downloadService.getFullRouteForFilesDownload() + encodeURIComponent(encodeURIComponent(this.dir))
    }
  },
  methods: {
    toggleExtended() {
      this.isExtended = !this.isExtended
    },
    showMessage() {
      this.setInfoMessageWithTimeout(this.$gettext('Stahování může chvíli trvat...'), 60000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/downloads/documents/Documents.vue